// src/API.ts

import { SubscriptionStatusResponse } from "billing/types/Subscriptions";
import { SubscriptionType } from "common/components/subscription/types/SubscriptionTypes";

export const API_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_URL) {
  // Optional: fail early in dev if env var is missing
  // eslint-disable-next-line no-console
  console.warn("REACT_APP_API_BASE_URL is not set. API calls will fail.");
}

export const subscriptionAPI = {
  // POST /api/create-checkout-session
  async createCheckoutSession(email: string, subscriptionType: SubscriptionType): Promise<{ url: string }> {
    const response = await fetch(`${API_URL}/subscription/create-checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, subscriptionType }),
    });

    if (!response.ok) {
      throw new Error("Failed to create checkout session");
    }

    return response.json(); // { url: string }
  },

  // GET /api/subscription-status?email=...
  async getSubscriptionStatus(email: string): Promise<SubscriptionStatusResponse> {
    const url = new URL(`${API_URL}/subscription/status`);
    url.searchParams.set("email", email);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch subscription status");
    }

    return response.json(); // { email, isPaying }
  },
  // POST /subscription/create-portal-session
  async createBillingPortalSession(email: string): Promise<{ url: string }> {
    const response = await fetch(`${API_URL}/subscription/create-portal-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error("Failed to create billing portal session");
    }

    return response.json();
  },
};
